
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { ComponentDocs, Preview } from "@lighting-beetle/lighter-styleguide";
import Button, { ButtonLayout } from "./../";
import ButtonLayouts from "./../ButtonLayouts";

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Button layouts`}</h1>
    <p>{`There are two button layouts: horizontal and vertical. Layouts can vary by breakpoint.`}</p>
    <h2>{`Example`}</h2>
    <ButtonLayout direction={{
      xs: "vertical",
      m: "horizontal"
    }} mdxType="ButtonLayout">
  <Button mdxType="Button">Button</Button>
  <Button mdxType="Button">Button</Button>
  <Button mdxType="Button">Button</Button>
    </ButtonLayout>
    <h2>{`Variants`}</h2>
    <h3>{`Horizontal`}</h3>
    <Preview mdxType="Preview">
  <ButtonLayout direction="horizontal" mdxType="ButtonLayout">
    <Button mdxType="Button">Button</Button>
    <Button mdxType="Button">Button</Button>
    <Button mdxType="Button">Button</Button>
  </ButtonLayout>
    </Preview>
    <h3>{`Vertical`}</h3>
    <Preview mdxType="Preview">
  <ButtonLayout direction="vertical" mdxType="ButtonLayout">
    <Button mdxType="Button">Button</Button>
    <Button mdxType="Button">Button</Button>
    <Button mdxType="Button">Button</Button>
  </ButtonLayout>
    </Preview>
    <h3>{`Responsive`}</h3>
    <p>{`Buttons are stacked vertically, on large screens the layout becomes horizontal.`}</p>
    <Preview mdxType="Preview">
  <ButtonLayout direction={{
        xs: "vertical",
        l: "horizontal"
      }} mdxType="ButtonLayout">
    <Button mdxType="Button">Button</Button>
    <Button mdxType="Button">Button</Button>
    <Button mdxType="Button">Button</Button>
  </ButtonLayout>
    </Preview>
    <h2>{`Props`}</h2>
    <ComponentDocs title="<ButtonLayout />" component={ButtonLayouts} excludes={["type"]} mdxType="ComponentDocs" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;